import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";

export default function OneService({ order, text = "" }) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <div 
      className="pb-5"
      data-aos="fade-right"
      style={{ cursor: "pointer" }}
    >
      <div
        className="text-center mt-3"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        {/* ORDER BADGE – sharp, modern badge (no circles) */}
        <div
          style={{
            width: "80px",
            height: "80px",
            background: "linear-gradient(135deg, #1a1a1a 0%, #333 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            border: "1px solid #333",
          }}
        >
          <span
            className="font-bold"
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#e2c000",
              lineHeight: 1,
              textShadow: "0 1px 2px rgba(0,0,0,0.3)",
            }}
          >
            {order}
          </span>
        </div>

        {/* TEXT PANEL – clean rectangle with sharp corners */}
        <div
          style={{
            flexGrow: 1,
            flexShrink: 1,
            minWidth: "180px",
            maxWidth: "400px",
            minHeight: "80px",
            background: "linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 24px",
            boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
            border: "1px solid #2d2d2d",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Subtle accent stripe on left */}
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "6px",
              background: "linear-gradient(to bottom, #e2c000, #d17000)",
            }}
          />
          <p 
            className="text-light font-semi-bold text-start"
            style={{
              fontSize: "16px",
              lineHeight: 1.5,
              margin: 0,
              color: "#f0f0f0",
              paddingLeft: "14px", // space for accent stripe
              fontWeight: 500,
            }}
          >
            {text}
          </p>
        </div>
      </div>
    </div>
  );
}